import { useLanguage } from "@/i18n";
import Reveal from "@/components/Reveal";

export default function Journey() {
  const { t } = useLanguage();
  return (
    <section id="journey" data-testid="journey-section" className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-ocean mb-4">{t.journey.kicker}</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-14 max-w-xl">{t.journey.title}</h2>
      </Reveal>

      <div className="relative max-w-2xl">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-gradient-to-b from-ocean via-sunset to-flame/40" />
        {t.journey.steps.map((step, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div className="relative pl-12 pb-12 last:pb-0" data-testid={`journey-step-${i}`}>
              <span className="absolute left-0 top-1.5 w-[15px] h-[15px] rounded-full bg-night border-2 border-sunset shadow-[0_0_16px_rgba(255,94,26,0.6)]" />
              <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                <span className="font-mono text-sm font-bold text-sunset">{step.time}</span>
                <span className="font-mono text-[11px] uppercase tracking-widest text-ocean">{step.tag}</span>
              </div>
              <h3 className="font-display text-xl sm:text-2xl font-bold mt-1.5">{step.title}</h3>
              <p className="text-sm sm:text-base text-slate-400 mt-1.5 leading-relaxed max-w-md">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
